import ImageRenderer from "components/rich-text/components/image";
import { SanityImage } from "components/rich-text/types";
import Image, { StaticImageData } from "next/image";
import React, { useMemo } from "react";

import styles from "./index.module.css";
import { IntegratorItem } from "./types";

type HeaderCellProps = { integrator: IntegratorItem };
const HeaderCell = ({ integrator }: HeaderCellProps) => {
  const content = useMemo(() => {
    let result = integrator.name;

    if (integrator.logo) {
      // Using a sanity image
      if ((integrator.logo as SanityImage).asset) {
        return (
          <ImageRenderer
            value={{ ...(integrator.logo as SanityImage), alt: `Logo - ${integrator.name}` }}
            objectFit="contain"
            layout="fill"
            withContainer={false}
          />
        );
      }

      return (
        <Image
          src={integrator.logo as StaticImageData}
          alt={`Logo - ${integrator.name}`}
          className="crispImage"
          layout="fill"
          objectFit="contain"
        />
      );
    }

    return result;
  }, [integrator]);
  return <div className={styles.integrationContent}>{content}</div>;
};

export default HeaderCell;
